A non-negative limit to the number of locations to return.

Defaults to 10.
